<div class="content">
    <div class="card">
      <div class="card-content">
        <div class="card-body">
  
          <button routerLink="/reportages" title="{{ 'inputs.back' | translate }}" mat-icon-button>
            <mat-icon>keyboard_backspace</mat-icon>
            {{ 'inputs.back' | translate }}
          </button>
  
          <h1>{{ 'titles.edit.upload_reportages_excel' | translate }}</h1>
  
          <div style="clear: left;"></div>
  
          <div class="media-body">
  
            <div class="contenedor" [formGroup]="reportageForm">
              <input matInput [hidden]="true" [formControlName]="'id'" type="text" placeholder="id">
  
              <mat-form-field class="columns">
                <mat-label *ngIf="selectedFiles; else newFile">{{selectedFiles.item(0).name}}</mat-label>
                <ng-template #newFile>
                  <mat-label>{{ 'inputs.choose_xls_file' | translate }}</mat-label>
                </ng-template>
                <input matInput disabled>
                <button mat-icon-button matSuffix (click)="fileInput_primary.click()">
                  <mat-icon>attach_file</mat-icon>
                </button>
                <input hidden (change)="selectFile($event, 'primary')" #fileInput_primary type="file" id="file"
                  accept={{type_accept}}>
              </mat-form-field>
  
              <!-- <mat-form-field class="columns">
                  <mat-label *ngIf="selectedSecondaryFiles; else newSecondaryFile">{{selectedSecondaryFiles.item(0).name}}
                  </mat-label>
                  <ng-template #newSecondaryFile>
                    <mat-label>{{ 'inputs.choose_secondary_image' | translate }}</mat-label>
                  </ng-template>
                  <input matInput disabled>
                  <button mat-icon-button matSuffix (click)="fileInput_secondary.click()">
                    <mat-icon>attach_file</mat-icon>
                  </button>
                  <input hidden (change)="selectFile($event, 'secondary')" #fileInput_secondary type="file"
                    id="secondaryfile" accept={{type_accept}}>
                </mat-form-field> -->
  
  
  
              <!-- <mat-progress-bar *ngIf="showReportagePhotosProgressBar2" mode="indeterminate"></mat-progress-bar> -->
  
  
              <div class="float-button-container">
                <button mat-fab color="primary" aria-label="save" (click)="uploadReportageRelationships()">
                  <mat-icon>save</mat-icon>
                </button>
              </div>
            </div>
            <div *ngIf="showPrimarySpinner" class="spinner-wrapper">
              <mat-spinner class="spinner-inner"></mat-spinner>
            </div>
  
  
  
  
            <div class="wpb_wrapper">
              <div class="vc_message_box vc_message_box-standard vc_message_box-rounded vc_color-info">
                <div class="vc_message_box-icon">
                  <mat-icon class="icon">info</mat-icon>
                </div>
                <p><b>Carga de relaciones para reportaje:</b><br>
                  El fichero de carga de relaciones debe contener los siguientes campos:</p>
                <ul>
                  <li>email (campo obligatorio).</li>
                </ul>
              </div>
            </div>
            <!-- Para descargar la plantilla pulse <a href="https://drive.google.com/file/d/1CU-p0Y74hN-rIuHuyqVCq_NuUW3bT9cP/view?usp=sharing" target="_blank" rel="noopener noreferrer">aquí</a> -->
            Para descargar la plantilla pulse <a
              href="https://storage.googleapis.com/maknetic.appspot.com/Plantilla%20subida%20reportages.xlsx" target="_blank"
              rel="noopener noreferrer">aquí</a>
  
  
          </div>
        </div>
      </div>
  
  
  
    </div>